(() => {
  const root = document.getElementById('ilf-mobile-ux');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const html = document.documentElement;
  const mobile = matchMedia('(max-width:767px)');
  const nav = root.querySelector('.ilf-bottom-nav');
  const bar = root.querySelector('.ilf-purchase-bar');
  const dialog = root.querySelector('dialog');
  const strings = JSON.parse(root.querySelector('[data-ilf-strings]').textContent);
  const product = root.querySelector('[data-ilf-product]');
  const config = product ? JSON.parse(product.textContent) : null;
  const main = document.querySelector('[id^="MainProduct-"]');
  const getForm = () => main?.querySelector('form[id^="product-form-"][action*="/cart/add"]');
  const getPicker = () => main?.querySelector('.product-detail__variant-picker');
  const reviewed = new Set();
  let frame = 0;
  let submitting = false;
  const track = (name, values = {}) => {
    if (!mobile.matches || window.Shopify?.designMode) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy?.analyticsProcessingAllowed?.()) return;
    window.Shopify?.analytics?.publish?.('ilf_mobile_' + name, {version:'nov2_v1', ...values});
  };
  const groups = () => Array.from(getPicker()?.querySelectorAll('fieldset') || []);
  const chosen = () => {
    const values = groups().map(group => group.querySelector('input[type="radio"]:checked')?.value ?? group.querySelector('select')?.value);
    if (config?.defaultOnly) return config.variants[0];
    return config?.variants.find(variant => variant.options.length === values.length && variant.options.every((value, i) => value === values[i]));
  };
  const ready = () => config?.defaultOnly || (groups().length > 0 && groups().every((group, i) => reviewed.has(i)));
  const goToOptions = () => {
    const target = getPicker() || getForm();
    if (!target) return;
    const reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
    const top = target.getBoundingClientRect().top + scrollY - 110;
    window.scrollTo({top:Math.max(0, top), behavior:reduce ? 'instant' : 'smooth'});
    const control = target.querySelector('input:not([type="hidden"]),select,button');
    control?.focus({preventScroll:true});
    track('options_requested');
  };
  const update = () => {
    frame = 0;
    html.classList.toggle('ilf-mobile-active', mobile.matches);
    const helpShadow = document.querySelector('#ilf-insights')?.shadowRoot;
    if (helpShadow && !helpShadow.querySelector('[data-ilf-mobile-offset]')) {
      const style = document.createElement('style');
      style.dataset.ilfMobileOffset = 'true';
      style.textContent = '@media(max-width:767px){.wrap{bottom:calc(72px + env(safe-area-inset-bottom,0px))!important}.panel{max-height:calc(100dvh - 170px)!important}}';
      helpShadow.append(style);
    }
    if (!mobile.matches) {
      if (dialog.open) dialog.close();
      return;
    }
    const form = getForm();
    const button = form?.querySelector('[name="add"]');
    if (!bar || !button) return;
    const rect = button.getBoundingClientRect();
    const sticky = rect.bottom <= 0;
    nav.hidden = sticky;
    bar.hidden = !sticky;
    const variant = chosen();
    const buy = bar.querySelector('[data-ilf-buy]');
    const price = bar.querySelector('[data-ilf-price]');
    const selection = bar.querySelector('[data-ilf-selection]');
    const synced = variant && String(variant.id) === form.querySelector('[name="id"]')?.value;
    price.textContent = variant?.price || '';
    selection.textContent = !config.defaultOnly && variant ? variant.options.join(' / ') : '';
    const loading = button.classList.contains('loading') || button.getAttribute('aria-disabled') === 'true';
    if (submitting && !loading) submitting = false;
    buy.disabled = loading || submitting;
    buy.textContent = loading ? strings.wait : !ready() ? strings.choose : !variant || !synced ? strings.review : !variant.available ? strings.sold : strings.add;
    if (ready() && variant && !variant.available) buy.disabled = true;
  };
  const schedule = () => {if (!frame) frame = requestAnimationFrame(update);};
  root.addEventListener('click', event => {
    const action = event.target.closest('[data-ilf-action]')?.dataset.ilfAction;
    if (action) track('navigation', {destination:action});
    if (action === 'shop') dialog.showModal();
    if (event.target.closest('[data-ilf-close]')) dialog.close();
    const category = event.target.closest('[data-ilf-category]');
    if (category) track('category_selected', {category:category.textContent.trim(), destination:category.getAttribute('href')});
    if (event.target.closest('[data-ilf-buy]')) {
      const form = getForm();
      const variant = chosen();
      const button = form?.querySelector('[name="add"]');
      if (!ready() || !variant || String(variant.id) !== form?.querySelector('[name="id"]')?.value) return goToOptions();
      if (!variant.available || !button || button.disabled) return goToOptions();
      const invalid = Array.from(main.querySelectorAll('input[required],select[required],textarea[required]')).find(el => !el.disabled && !el.checkValidity());
      if (invalid) {invalid.scrollIntoView({block:'center',behavior:'smooth'});invalid.reportValidity();return;}
      if (!form.reportValidity()) return goToOptions();
      track('sticky_add_attempt', {product_id:root.dataset.product, variant_id:String(variant.id)});
      submitting = true;
      button.click();
      schedule();
    }
  });
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => html.classList.remove('ilf-mobile-dialog'));
  new MutationObserver(() => html.classList.toggle('ilf-mobile-dialog', dialog.open)).observe(dialog,{attributes:true,attributeFilter:['open']});
  main?.addEventListener('click', event => {
    const group = event.target.closest('.product-detail__variant-picker fieldset');
    if (group && (event.target.closest('label') || event.target.matches('input[type="radio"]'))) {reviewed.add(groups().indexOf(group));schedule();}
  });
  main?.addEventListener('change', event => {
    const group = event.target.closest('.product-detail__variant-picker fieldset');
    if (group) reviewed.add(groups().indexOf(group));
    schedule();
  });
  if (main) new MutationObserver(schedule).observe(main,{subtree:true,childList:true,attributes:true,attributeFilter:['value','disabled','class','aria-disabled']});
  new MutationObserver(schedule).observe(document.body,{childList:true});
  addEventListener('load',schedule,{once:true});
  addEventListener('scroll',schedule,{passive:true});
  addEventListener('resize',schedule,{passive:true});
  mobile.addEventListener('change',schedule);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', () => {
    const keyboard = innerHeight - window.visualViewport.height > 160;
    root.style.visibility = keyboard ? 'hidden' : '';
  });
  document.addEventListener('visitorConsentCollected', () => track('exposure'));
  document.addEventListener('shopify:section:load',schedule);
  track('exposure');
  update();
})();
